// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Image_wrapper__1HTe0","img":"Image_img__2QHZ6","skeleton":"Image_skeleton__3Ytmv"};